export const trigger = <K extends keyof DocumentEventMap>(element: Element | null, name: K, eventOptions?: any): void => {

  if (!element) {
      console.warn(`Element not found.`);
      return;
  }

  let event: Event;
  

  switch (name) {
      case 'click':
      case 'dblclick':
      case 'mouseover':
      case 'mouseout':
          event = new MouseEvent(name, eventOptions);
          break;
      case 'keydown':
      case 'keyup':
          event = new KeyboardEvent(name, eventOptions);
          break;
      default:
          event = new Event(name, eventOptions);
          break;
  }

  element.dispatchEvent(event);
}